<template>
    <div>
        <div id="wallet_container" v-show="loaded == true" />
        <PreparingPlataform v-if="loaded == false" />
    </div>
</template>

<script>
import PreparingPlataform from "@/components/shared/Payment/PreparingPlataform";

export default {
    components: { PreparingPlataform },

    props: {
        charger: {
            required: true,
        },
        chargerName: {
            required: true,
        },
        plugNumber: {
            required: true,
        },
        price: {
            required: true,
        },
    },

    data() {
        return {
            PREFERENCE_ID: null,
            PUBLIC_KEY: null,
            loaded: false,
        };
    },

    mounted() {
        setTimeout(() => {
            this.createPreference();
        }, 3000);

        this.$eventHub.$on("changePaymentEmail", this.recreateButton);
    },

    methods: {
        recreateButton() {
            this.loaded = false;
            this.createPreference();
        },
        createPreference() {
            this.$http
                .postDynamic(this.charger.server, "api/v2/payment/create", {
                    operator: "mercadopago",
                    chargerName: this.chargerName,
                    plugNumber: this.plugNumber,
                    email: (this.$store.state.payment.email) ? this.$store.state.payment.email : null,
                    userId: (this.$store.state.user.ID) ? this.$store.state.user.ID : "NO_USER",
                    price: this.price
                }).then((result) => {
                    if (result && result && result.id) {
                        this.PREFERENCE_ID = result.id;
                        this.PUBLIC_KEY = result.pk;
                        this.start()
                    }
                }).catch(error => {
                    console.log(error)
                    this.$eventHub.$emit("msgError", error.message ? error.message : "Erro ao validar carregador.");
                });

        },
        start() {
            const mercadopago = new window.MercadoPago(this.PUBLIC_KEY, {
                locale: "pt-BR",
            });
            mercadopago.bricks().create("wallet", "wallet_container", {
                initialization: {
                    preferenceId: this.PREFERENCE_ID,
                },
                customization: {
                    texts: {
                        valueProp: 'smart_option',
                    },
                },
            });

            setTimeout(() => {
                this.loaded = true;
            }, 3000);
        },
    }
}

</script>